<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
html, body, #app {
  margin: 0;
  padding: 0;
  font-family: 'Poppins', sans-serif;
  background-color: white;
  color: rgb(63, 63, 63);
}

button, select {
    display: flex;
    font-weight: 600;
    font-size: 15px;
    border-radius: 5px;
    background-image: linear-gradient(90deg,#672583,#00a1ae);
    box-shadow: 0 5px 10px 1px hsl(0deg 0% 45% / 44%);
    color: #fff;
    padding: 8px 14px;
    cursor: pointer;
    border: none;

    transition: .2s;
}

select {
  color: black;
}

button:hover {
  background-color: rgba(0, 0, 0, 0.11);

  transition: .2s;
}


button:active {
  background-color: rgba(0, 0, 0, 0.781);
  color: white;

  transition: .2s;
}

button:disabled, input:disabled {
  opacity: .5;
}

a {
  color: white;
}

input {
  border: none;
  border-radius: 10px;
  padding: 10px;
  background: rgba(0, 0, 0, 0.226);
  color: black;
}

input[type=color] {
  background: none;
  padding: 0
}

table {
  width: 100%;
  border-collapse: collapse;
}

thead {
  border-bottom: 1px solid #672583;
}

th {
  text-align: left;
}

td {
  border: 1px solid transparent;
  padding: 8px;
}


tr:nth-child(even){background-color: #67258338}

tr:hover {background-color: #ddd;}

@keyframes fadein {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

.fadein {
  animation: fadein 1s 1;
}

.select {
  display: flex;
}

.select > .item {
  border: 1px solid black;
  padding: 10px 5px;
  font-weight: 500;
  background-color: white;

  transition: .2s;
}

.select > .item.selected {
  color: white;
  background-image: linear-gradient(90deg,#672583,#00a1ae);
}

.select > .item.first {
  border-bottom-left-radius: 10px;
  border-top-left-radius: 10px;
}


.select > .item.last {
  border-bottom-right-radius: 10px;
  border-top-right-radius: 10px;
}


</style>



// WEBPACK FOOTER //
// src/App.vue